import axios from '@/plugins/axios'

export default {
  async doLogin(context, payload) {
    context.commit('loading')
    return axios.post('/auth/login', payload).then(response => {
      const data = response.data.data
      context.commit('AUTH_USER', data)
      context.commit('store/MY_STORE_ID', data.user.tenant.store)
      context.commit('loadingFail')
      return response
    })
  },
  async signUp(context, payload) {
    context.commit('loading')
    return axios.post('signup', payload).then(function (response) {
      const data = response.data.data
      context.commit('AUTH_USER', data)
      context.commit('store/MY_STORE_ID', data.user.store)
      context.commit('loadingFail')
      return response
    })
  },
  async RECOVER_PASSWORD(context, payload) {
    context.commit('loading')
    return axios.post('/auth/password/email', payload).then(function (response) {
      context.commit('loadingFail')
    })
  },
  async NEW_PASSWORD(context, payload) {
    context.commit('loading')
    const config = {
      validateStatus: function (status) {
        return status >= 200 && status < 300
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .post('/auth/password/reset', payload, config)
        .then(function (response) {
          context.commit('loadingFail')
          resolve(response)
        })
        .catch(error => {
          context.commit('loadingFail')
          reject(error)
        })
    })
  },
  async TOKEN_CONFIRMATION(context, payload) {
    context.commit('loading')
    return new Promise((resolve, reject) => {
      axios
        .get(`/auth/email/verify/${payload.id}/${payload.hash}`, {
          params: payload.params
        })
        .then(function (response) {
          context.commit('loadingFail')
          resolve(response)
        })
        .catch(error => {
          context.commit('loadingFail')
          reject(error)
        })
    })
  },
  async LOGOUT_USER({ commit }) {
    commit('LOGOUT')
    commit('store/MY_STORE_ID', null)
  },
  async CHECK_TOKEN_APP({ commit, state }) {
    const data = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    const user = await axios.post('/auth/me', {}, data)
    return new Promise((resolve, reject) => {
      commit('USER_INFO', {})
      if (state.access_token) {
        commit('USER_INFO', user.data.data.user)
        commit('store/MY_STORE_ID', user.data.data.user.tenant.store)
        commit('loadingFail')
        resolve(user)
      }
    })
  }
}
